<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">结算报表名称</span>
        <Input v-model="searchParams.reportName" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">报表类型</span>
        <Select v-model="searchParams.reportType" transfer placeholder="请选择" clearable>
          <Option value="4-2">出单活动-梯度</Option>
          <Option value="2-2">增员活动-梯度</Option>
          <Option value="2-1">增员活动-无门槛</Option>
          <Option value="4-1">出单活动-无门槛</Option>
          <Option value="5-2">签约活动</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">关联活动</span>
        <Select v-model="searchParams.activityId" transfer placeholder="请选择" clearable filterable>
          <Option :value="item.id" v-for="(item, index) in activityList" :key="index">{{ item.name }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">结算机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已结算</Option>
          <Option value="0">待结算</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>
    <Button type="primary" class="btn" @click="addNewReport">新建结算报表</Button>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="reportName">
          <span class="table-btn" @click="toDetailPage(row)">{{ row.reportName }}</span>
        </template>
        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">待结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="delRow(row)" v-if="row.settlementStatus != 1">删除</span>
          <span class="disabled" v-else>删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree
  },
  data() {
    return {
      searchParams: {},
      total: null,
      columns: [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '报表名称',
          align: 'center',
          key: 'reportName',
          minWidth: 250,
          slot: 'reportName'
        },
        {
          title: '报表类型',
          align: 'center',
          key: 'type',
          width: 120,
          render(h, params) {
            let type = params.row.type;
            const map = {
              '2': '增员活动',
              '4': '出单活动',
              '5': '签约活动',
            };
            return <span>{map[params.row.type] || '-'}</span>;
          }
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250,
          tooltip: true
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '发布状态',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let releaseStatus = params.row.releaseStatus;
            if (releaseStatus == 1) {
              return <span>已发布</span>;
            } else if (releaseStatus == 0) {
              return <span>待发布</span>;
            }
          }
        },
        {
          title: '参加人数',
          align: 'center',
          key: 'userNum',
          minWidth: 120
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 120
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120,
          fixed: 'right'
        }
      ],
      activityList: [],
      tableData: []
    };
  },

  activated() {
    this.getList();
    this.getActivityList();
  },

  methods: {
    resetSearch() {
      this.searchParams = {};
      this.searchAjax();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    // 获取关联活动
    getActivityList() {
      this.$http({
        url: '/buz/merchantActivity/getList',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          statusList: [1, -1]
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },

    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      data.commissionDate = data.commissionDate && filter.filterTime(data.commissionDate, 'YYYY-MM-DD');
      // 结算日期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      delete data.settlementDate;
      if (data.reportType) {
        const arr = data.reportType.split('-');
        data.type = arr[0];
        data.activityType = arr[1];
      } else {
        data.typeList = [2, 4, 5];
      }
      delete data.reportType;
      this.$http({
        url: '/buz/userSettlementReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 详情
    toDetailPage(row) {
      let step = row.step;
      if (step == 1) {
        this.openPageTabTags('/financialManage/activitySettlement/editReport', {
          reportId: row.id,
          isAdd: 0,
          step: '1',
          reportName: row.reportName
        });
      } else {
        this.openPageTabTags('/financialManage/activitySettlement/editReport', {
          reportId: row.id,
          step,
          reportName: row.reportName,
          type: row.type,
          activityType: row.activityType,
          settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD'), //结算日期
          productType: row.activityProductType
        });
      }
    },

    // 删除
    delRow(row) {
      if (!this.$units.pointAction('offline_81_4_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/userSettlementReport/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList();
        });
      });
    },

    // 新建结算报表
    addNewReport() {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.openPageTabTags('/financialManage/activitySettlement/newReport', { isAdd: 1, step: '1', reportName: '新建结算报表', time: Date.now() });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
  .disabled {
    color: #bbbeb8;
  }
  .disabled:hover {
    cursor: no-drop;
  }
  .settlement-status {
    display: flex;
    .tag-settled {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      font-size: 13px;
      color: #e3461f;
      border: 1px solid #ffc1b2;
      background: #fff5f2;
    }
    .tag-be {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      font-size: 13px;
      color: #35bf3f;
      border: 1px solid #abeaae;
      background: #f6fcf4;
    }
  }
}
</style>
